<template>
  <div class="partner">
    <el-container>
      <el-main  style="margin:0px;padding:0px;" >
        <el-row  style="margin:0px;padding:0px;">
          <span style="font-size: 22px;">合作伙伴</span>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/sixin.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">厦门四信通信科技有限公司（中国物联网无线通信领域骨干企业）。</span>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'seedTracePage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.partner {
  margin-left: 10px;
  padding-left: 10px;
  height: 500px;
}
.el-row {
  margin-top: 0px;
  padding-top: 10px;
  text-align: left;
}
</style>
